import themes from 'devextreme/ui/themes';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { loadMessages, locale } from 'devextreme/localization';
import trMessages from 'devextreme/localization/messages/tr.json';

loadMessages(trMessages);
locale('tr');

themes.initialized(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
